import type { AnyAction, ThunkAction } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getProductsQuerySyncPayloadFromURL } from '../helpers/getProductsQuerySyncPayloadFromURL';
import { actions } from '../slice';

export const syncFromURL = (
  asPath: string,
): ThunkAction<void, ReduxApplicationState, undefined, AnyAction> => {
  return (dispatch, getState) => {
    const state = getState();
    const payload = getProductsQuerySyncPayloadFromURL(asPath, state);

    dispatch(actions.syncFromURLPayload({ ...payload, asPath }));
  };
};
